module.exports = __webpack_public_path__ + "officialStatic/img/logo15.0997508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo15.png
// module id = QPet
// module chunks = 0